



































import {
    Vue, Component, Prop, PropSync, Mixins, Watch,
} from 'vue-property-decorator'
import {VueCropper} from 'vue-cropper'

@Component({
    components: {
        VueCropper,
    },
})
export default class ClippingImage extends Vue {
    $refs!: {
        cropper: any
    }

    @Prop({default: ''}) file!: any

    @Prop({
        default() {
            return [3, 4]
        },
    }) fixedNumber!: any[]

    @Prop({
        default() {
            return [300, 400]
        },
    }) autoCropSize!: any[]

    @PropSync('visible', {default: false}) clippingVisible!: boolean

    option: any = {
        size: 0.6,
        original: false,
        full: true,
        centerBox: true,
        autoCrop: true,
    }

    done() {
        this.$refs.cropper.getCropBlob(data => {
            this.$emit('done', new File([data], 'temp.jpeg'))
            this.clippingVisible = false
        })
    }

    cancel() {
        this.$refs.cropper.getCropBlob(data => {
            this.$emit('cancel')
            this.clippingVisible = false
        })
    }
}
